import styled from "styled-components";

const FullRow = styled.div`
  grid-column: 1 / -1;
`;

export default FullRow;
